import { createFileRoute, Outlet } from "@tanstack/react-router";

import {
  SETTINGS_SIDEBAR_NAME,
  SettingsSidebar,
} from "~/components/layout/sidebars/settings-sidebar";
import { SidebarProvider } from "~/components/ui/sidebar";

export const Route = createFileRoute("/_auth/_app_shell/_settings-navigation")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SidebarProvider sidebarNames={[SETTINGS_SIDEBAR_NAME]}>
      <SettingsSidebar name={SETTINGS_SIDEBAR_NAME} variant="inset" />
      <main className="h-svh w-full overflow-hidden md:p-2">
        <div className="bg-container flex size-full overflow-hidden md:rounded-md md:border">
          <Outlet />
        </div>
      </main>
    </SidebarProvider>
  );
}
